import { render, staticRenderFns } from "./Eggos.vue?vue&type=template&id=013332ec&scoped=true&"
import script from "./Eggos.vue?vue&type=script&lang=js&"
export * from "./Eggos.vue?vue&type=script&lang=js&"
import style0 from "./Eggos.vue?vue&type=style&index=0&id=013332ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013332ec",
  null
  
)

export default component.exports